require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-15-yrfixeddisclosure.json") })
        }
      }, "path---es-15-yrfixeddisclosure");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-15-yrfixeddisclosure!./.cache/json/es-15-yrfixeddisclosure.json
// module id = 2009
// module chunks = 231608221292675